<div class="back-to-welcome-container light-control-host">
  @if (showBackToWelcome) {
    <button class="arpio-button small-button back-to-welcome" (click)="navigateBackToWelcome()">
      <i class="fa-solid fa-arrow-left"></i> Back to Welcome
    </button>
  }
  @if (showBackToWelcome) {
    <div class="back-to-welcome-spacer"></div>
  }
  <div id="access-managment-container" class="content-block light-control-host">
    <div class="header-container">
      <div>
        <h1>Access Management</h1>
      </div>
    </div>

    <app-tabs [tabs]="tabs" [baseRoute]="baseRoute" [scrollTargetId]="'access-management-content'"></app-tabs>

    <div id="access-management-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
